import React, { FC, useEffect, useRef, useState } from "react";
import moment from "moment/moment";

export const toValueLabel = (obj) => {
  let ary = [];
  if (obj) {
    // ary = Object.entries(obj).map(([key, value]) => ({ key, value }));

    // for (var key in Object.keys(obj)) {
    for (var key in obj) {
      // const o = obj[Number(key)];
      const o = obj[key];
      ary.push({ value: key, label: o });
    }
  } else {
  }

  return ary;
};

export const toMomentString = (obj, formatStr) => {
  //   if (moment.isMoment(obj)) {
  //     return obj.format(formatStr);
  //   }
  if (obj) {
    const mom = moment(obj);
    if (mom.isValid()) {
      return mom.format(formatStr);
    }
  }

  return "";
};

export const getMessage = (error) => {
  let message = "";

  if (error.response) {
    const data = error.response.data;
    if (data) {
      if (data.errors) {
        if (Object.keys(data.errors).length == 0) {
          message = data.message;
        } else {
          let err1 = data.errors[Object.keys(data.errors)[0]];
          message = err1;
        }
      } else {
        message = data.message;
      }
    }
  } else {
    message = error.message;
  }
  return message;
};

export const toRound = (num, n) => {
  const a = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
  return a;
};

export const toRoundFixed = (num, n) => {
  const a = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
  return a.toFixed(n);
};

// export const toNumber = (num, n) => {
//   try {
//     if (!num) return <></>;

//     const a = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);

//     const b = a.toFixed(n);
//     const declist = b.split(".")[1].split("");

//     let decindex = 0;

//     const rev = declist.concat().reverse();
//     for (const i in rev) {
//       if (rev[i] != 0) {
//         decindex = rev.length - i;
//         break;
//       }
//     }

//     return (
//       <>
//         {b.split(".")[0]}
//         {declist.every((d) => d == 0) ? " " : "."}
//         {declist.map((_, idx) => {
//           if (idx >= decindex) {
//             return <span style={{ color: "transparent" }}>{_}</span>;
//           } else {
//             return <span>{_}</span>;
//           }
//         })}
//       </>
//     );
//   } catch (error) {
//     console.log(error);
//   }
// };

export const toNumber = (num, n) => {
  if (!num) return "";
  if (num === "　") return "　";
  const number = Number(num);

  if (!isNumber(number)) return "";

  if (n) {
    return Number(num).toLocaleString(undefined, { maximumFractionDigits: n });
  }
  return Number(num).toLocaleString(undefined, { maximumFractionDigits: 20 });
};

// 丸めて欲しくない場合には、maximumFractionDigitsオプションを使用します。
// var num = 12345.6789;
// num.toLocaleString( undefined, { maximumFractionDigits: 20 });  // "12,345.6789"

function comma(num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

const isNumber = function(value) {
  return typeof value === "number" && isFinite(value);
};
